import Api from './api'
import store from '@/store'

const resource = '/replies'
export default {
  get(page = 1) {
    return Api.get(`${resource}/index/${store.state.route.params.category}/${store.state.route.params.channel}/${store.state.route.params.thread}?page=${page}`)
  },
  create(data) {
    return Api.put(`${resource}/store/${store.state.route.params.category}/${store.state.route.params.channel}/${store.state.route.params.thread}`, data)
  },
  update(replyId, data) {
    return Api.patch(`${resource}/update/${store.state.route.params.category}/${store.state.route.params.channel}/${store.state.route.params.thread}/${replyId}`, data)
  },
  destroy(replyId) {
    return Api.delete(`${resource}/destroy/${store.state.route.params.category}/${store.state.route.params.channel}/${store.state.route.params.thread}/${replyId}`)
  }
}
